const EDIT_NOTICE_DRAFT_PREFIX = 'admin:noticeDraft:edit:'
export const NEW_NOTICE_DRAFT_KEY = 'admin:noticeDraft:new'

const NOTICE_DRAFT_FIELDS = [
    'title',
    'titleSub',
    'content',
    'url',
    'status',
    'order',
]

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const parseNumberValue = (value, fallbackValue) => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

// 공지사항 폼에서 다시 입력 비용이 큰 값만 sessionStorage에 남긴다.
export const createNoticeDraftPayload = ({ data = {} }) => {
    return {
        data: {
            title: data.title || '',
            titleSub: data.titleSub || '',
            content: data.content || '',
            url: data.url || '',
            status: data.status ?? 0,
            order: data.order ?? 0,
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 작성 흐름을 이어간다.
export const applyNoticeDraft = ({ baseData = {}, draft }) => {
    if (!draft) {
        return {
            data: baseData,
        }
    }

    const draftData = draft.data || {}
    const nextData = {
        ...baseData,
    }

    NOTICE_DRAFT_FIELDS.forEach((field) => {
        if (draftData[field] === undefined) {
            return
        }

        if (field === 'status' || field === 'order') {
            nextData[field] = parseNumberValue(draftData[field], baseData[field] ?? 0)
            return
        }

        nextData[field] = draftData[field]
    })

    return {
        data: nextData,
    }
}

export const createEditNoticeDraftKey = (noticeId) => `${EDIT_NOTICE_DRAFT_PREFIX}${noticeId}`

export const readNoticeDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveNoticeDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 작성 흐름은 그대로 유지한다.
    }
}

export const clearNoticeDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
